import { render, staticRenderFns } from "./homepageTemplate.vue?vue&type=template&id=16e07064&scoped=true"
import script from "./homepageTemplate.vue?vue&type=script&lang=js"
export * from "./homepageTemplate.vue?vue&type=script&lang=js"
import style0 from "./homepageTemplate.vue?vue&type=style&index=0&id=16e07064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e07064",
  null
  
)

export default component.exports